import React from 'react';

const CsrPageHeader = ({ title, subtitle, csr, adminId, badge = 'Impact metrics pending', onScopeChange }) => {
  const { coverageStatus, eyebrow, partner, scope, stateOptions, coverageByKey, isNoDataScope } = csr;
  return (
    <header className="csr-header">
      <div className="csr-header__text">
        <span className="csr-eyebrow"><span className="csr-dot" />{coverageStatus === 'success' ? eyebrow : 'CSR & NGO partner dashboard'}</span>
        <h1 className="csr-title">{title}</h1>
        <p className="csr-sub">
          <span>{`${subtitle}${partner?.entity_name ? ` for ${partner.entity_name}` : ''}.`}</span>
          {adminId && partner?.category ? <span className="csr-chip">{partner.category.toUpperCase()}</span> : null}
        </p>
      </div>
      {coverageStatus === 'success' ? (
        <div className="csr-controls">
          <label htmlFor="csr-state">State</label>
          <select
            id="csr-state"
            className={`csr-select ${isNoDataScope ? 'is-nodata' : ''}`}
            value={scope}
            onChange={(e) => onScopeChange(e.target.value)}
          >
            <option value="all">All India</option>
            {stateOptions.map((o) => (
              <option key={o.key} value={o.key}>{coverageByKey.has(o.key) ? o.name : `${o.name} · no data`}</option>
            ))}
          </select>
          {badge ? <span className="csr-badge">{badge}</span> : null}
        </div>
      ) : null}
    </header>
  );
};

export default CsrPageHeader;
